<template>
  <div>
    <skeleton-body :skeleton="skeletonBody" />
    <div class="row" v-if="!skeletonBody">
      <div class="col-12">
        <card>
          <div class="row content-add-btn">
            <div class="col-5" v-if="isCreate()">
              <div class="text-left">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="$router.push('/quality/quality/create')"
                >
                  <em class="fa fa-plus"></em>
                  {{ $t('quality.quality_testing_add') }}
                </button>
              </div>
            </div>
            <div class="col-12 text-center">
              <hr />
            </div>
            <el-dialog
              top="2%"
              v-if="isShow()"
              :title="nameQualitySelected"
              :visible.sync="modals.read"
              width="80%"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <div class="card" v-if="rowData">
                <div class="card-body" v-if="rowData">
                  <table aria-describedby="tabla-calidad" class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.name') }}</strong>
                          </h6>
                          {{ rowData.name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{
                              $t('common_words.description')
                            }}</strong>
                          </h6>
                          {{ rowData.description }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.type_grade') }}</strong>
                          </h6>
                          {{ rowData.type }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{
                              $t('common_words.type_capture')
                            }}</strong>
                          </h6>
                          {{ rowData.quality_type_label }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_companies')
                            }}</strong>
                          </h6>
                          <span
                            v-for="(
                              business, index
                            ) in rowData.businesses_names"
                            :key="index"
                          >
                            <el-tag type="info">{{ business }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_profiles2')
                            }}</strong>
                          </h6>
                          <template v-if="rowData.roles_name.length > 0">
                            <span
                              v-for="(role, index) in rowData.roles_name"
                              :key="index"
                            >
                              <el-tag type="info">{{ role }}</el-tag>
                            </span>
                          </template>
                          <el-tag v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_users2')
                            }}</strong>
                          </h6>
                          <template v-if="rowData.users_name.length > 0">
                            <span
                              v-for="(user, index) in rowData.users_name"
                              :key="index"
                            >
                              <el-tag type="info">{{ user }}</el-tag>
                            </span>
                          </template>
                          <el-tag v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.sub_associated_category')
                            }}</strong>
                          </h6>
                          <div
                            v-if="rowData.sub_categories.length > 0"
                            class="row table"
                          >
                            <div class="col-2 border-bottom pd-3"></div>
                            <div class="col-10 border-bottom pl-1 pd-3">
                              <div class="row">
                                <div
                                  class="col-3 mt-2 pl-0 pb-2 text-muted fs-12"
                                >
                                  {{ $t('common_words.mayus_tasks') }}
                                </div>
                                <div
                                  class="col-2 mt-2 pl-1 pb-2 text-muted fs-12"
                                >
                                  {{ $t('common_words.mayus_type') }}
                                </div>
                                <div
                                  class="col-3 mt-2 pl-1 pb-2 text-muted fs-12"
                                >
                                  {{
                                    $t('common_words.mayus_associated_value')
                                  }}
                                </div>
                                <div
                                  class="col-2 mt-2 pl-2 pb-2 text-muted fs-12"
                                >
                                  {{ $t('common_words.photo_questionmark') }}
                                </div>
                                <div
                                  class="col-2 mt-2 pl-2 pb-2 text-muted fs-12"
                                >
                                  {{ $t('common_words.required_questionmark') }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row table border-bottom mt-0"
                            v-for="(subcat, index) in rowData.sub_categories"
                            :key="index"
                          >
                            <div class="col-2 pl-0">
                              <el-tag type="info">
                                <span
                                  v-tooltip.top-center="
                                    subcat.name.length > 15
                                      ? `${subcat.order} - ${subcat.name}`
                                      : ``
                                  "
                                >
                                  {{ subcat.order }} -
                                  {{ subcat.name.substring(0, 15)
                                  }}{{ subcat.name.length > 15 ? `...` : `` }}
                                </span>
                              </el-tag>
                            </div>
                            <div class="col-10 pl-1 pr-0">
                              <div class="row">
                                <div
                                  class="body-info-table col-3 text-break pl-1 pr-1"
                                >
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-for="(task, j) in subcat.quality_tasks"
                                    :key="j"
                                  >
                                    <span
                                      v-tooltip.top-center="
                                        task.name.length > 32
                                          ? `${task.order} - ${task.name}`
                                          : ``
                                      "
                                    >
                                      {{ task.order }} -
                                      {{ task.name.substring(0, 32)
                                      }}{{ task.name.length > 32 ? `...` : `` }}
                                    </span>
                                  </p>
                                </div>
                                <div
                                  class="body-info-table col-2 text-break pl-0 pr-1"
                                >
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-for="(task, j) in subcat.quality_tasks"
                                    :key="j"
                                  >
                                    {{ task.calification_type }}
                                  </p>
                                </div>
                                <div
                                  class="body-info-table col-3 text-break pl-0 pr-1"
                                >
                                  <template
                                    v-for="(task, j) in subcat.quality_tasks"
                                  >
                                    <p
                                      class="d-flex align-items-center border-bottom size-cell"
                                      :key="j"
                                      v-if="
                                        [
                                          'Fuente de Datos',
                                          'Fuente de Datos Múltiple',
                                        ].includes(task.calification_type)
                                      "
                                    >
                                      {{
                                        task.quality_option_tasks[0]
                                          .data_source_label
                                      }}
                                    </p>
                                    <p
                                      v-tooltip.top-center="
                                        showDialogOptionTask(
                                          task.quality_option_tasks
                                        ).length > 50
                                          ? showDialogOptionTask(
                                              task.quality_option_tasks
                                            )
                                          : ``
                                      "
                                      class="d-flex align-items-center border-bottom size-cell"
                                      v-else-if="
                                        ['Única', 'Múltiple'].includes(
                                          task.calification_type
                                        )
                                      "
                                    >
                                      {{
                                        showDialogOptionTask(
                                          task.quality_option_tasks
                                        ).substring(0, 50)
                                      }}
                                      {{
                                        showDialogOptionTask(
                                          task.quality_option_tasks
                                        ).length > 50
                                          ? `...`
                                          : ``
                                      }}
                                    </p>
                                    <p
                                      class="d-flex align-items-center border-bottom size-cell"
                                      v-else-if="
                                        ['Numérica', 'Texto'].includes(
                                          task.calification_type
                                        )
                                      "
                                    >
                                      <label
                                        class="font-weight-light"
                                        style="font-size: 14px"
                                      >
                                        {{
                                          'Min: ' +
                                          roundNumber(task.minimum, 2) +
                                          ' - Max: ' +
                                          roundNumber(task.maximum, 2)
                                        }}
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center border-bottom size-cell"
                                      v-else-if="
                                        task.calification_type == 'Subjetiva'
                                      "
                                    >
                                      <label class="row subject-calification">
                                        <div class="px-0 mr-1">
                                          <el-tag closable type="info">
                                            0
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag closable type="info">
                                            10
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag closable type="info">
                                            NA
                                          </el-tag>
                                        </div>
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center border-bottom size-cell"
                                      v-else
                                    >
                                      {{ $t('common_words.does_not_apply') }}
                                    </p>
                                  </template>
                                </div>
                                <div
                                  class="body-info-table col-2 text-break pl-0 pr-1"
                                >
                                  <template
                                    v-for="(task, j) in subcat.quality_tasks"
                                  >
                                    <p
                                      v-if="task.photo_required !== undefined"
                                      class="d-flex align-items-center border-bottom size-cell"
                                      :key="j"
                                    >
                                      {{
                                        task.photo_required === 1 ? 'Si' : 'No'
                                      }}
                                    </p>
                                    <p v-else></p>
                                  </template>
                                </div>
                                <div
                                  class="body-info-table col-2 text-break pl-0 pr-1"
                                >
                                  <template
                                    v-for="(task, j) in subcat.quality_tasks"
                                  >
                                    <p
                                      v-if="task.is_required !== undefined"
                                      class="d-flex align-items-center border-bottom size-cell"
                                      :key="j"
                                    >
                                      {{ task.is_required === 1 ? 'Si' : 'No' }}
                                    </p>
                                    <p v-else>{{ $t('common_words.no') }}</p>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                          <el-tag
                            type="warning"
                            v-if="rowData.sub_categories.length == 0"
                            >{{
                              $t('common_words.no_sub_associated_category')
                            }}</el-tag
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer footer-date-at" v-if="rowData">
                  <p class="text-white">
                    <small
                      >{{ $t('common_words.created_on') }}:
                      {{ rowData.created_at }}</small
                    >
                  </p>
                </div>
              </div>
            </el-dialog>
          </div>
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                max-height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  :label="$t('common_words.companies')"
                  min-width="120"
                  prop="businesses_names"
                  :sortable="true"
                  :resizable="false"
                  :align="'center'"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.businesses_names.length > 0"
                      :hidden="
                        scope.row.businesses_names.length == 1 ? true : false
                      "
                      :value="200"
                      :max="scope.row.businesses_names.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.businesses_names[0] }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common_words.associated_sub_category')"
                  min-width="120"
                  prop="sub_categories[0].name"
                  :sortable="true"
                  :resizable="false"
                  :align="'center'"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.sub_categories.length > 0"
                      :hidden="
                        scope.row.sub_categories.length == 1 ? true : false
                      "
                      :value="200"
                      :max="scope.row.sub_categories.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.sub_categories[0].name }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isShow() || isUpdate() || isDelete()"
                  :min-width="90"
                  :label="$t('common_words.operations')"
                  fixed="right"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isShow()"
                        v-tooltip.top-center="$t('common_words.view')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="handleView(props.$index, props.row)"
                      >
                        <em class="fa fa-eye custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.edit')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="handleEdit(props.$index, props.row)"
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('quality.doesNotHavePermissionsToIndex') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
      </div>
    </div>
    <div
      class="row"
      v-if="!skeletonBody"
      style="padding-right: 13px; padding-left: 13px"
    >
      <div class="col-6" v-if="isPDF()">
        <div class="text-right">
          <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
            <em class="fa fa-file-pdf-o"></em>
            {{ $t('common_words.export_to_pdf') }}
          </button>
        </div>
      </div>
      <div class="col-6" v-if="isExcel()">
        <div class="text-left">
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="exportToExcel"
          >
            <em class="fa fa-file-excel-o"></em>
            {{ $t('common_words.export_to_excel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { Slider } from 'element-ui';
import configTable from './qualityTable';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinSkeleton from 'src/util/mixinSkeleton';
import moment from 'moment';
import SkeletonBody from 'src/components/SkeletonBody.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
    [Slider.name]: Slider,
    [SkeletonBody.name]: SkeletonBody,
  },

  computed: {
    ...configTable().Search,
    nameQualitySelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },

  data() {
    return {
      qualityForm: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinMasters,
    MixinExport,
    MixinNumbers,
    MixinSkeleton,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    showDialogOptionTask(data) {
      const items = data.map(function (item) {
        return item.name;
      });

      return `["${items.join('", "')}"]`;
    },

    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = '/quality/edit';
      this.qualityForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.qualityForm));
      this.$router.push({
        path: 'quality/edit',
      });
    },

    handleDelete(index, row) {
      this.qualityForm = Object.assign({}, row);
      SweetAlert.delete(this.qualityForm.name).then((result) => {
        if (result.value) this.deleteQuality();
      });
    },

    deleteQuality() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.qualityForm.route = 'quality/quality';
        Axios.destroyMaster(this.qualityForm)
          .then((response) => {
            this.modifyTable(2, this.qualityForm.id, response);
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'quality/quality/pdf';
      data.name_file = `${i18n.t('quality.quality')}.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'quality/quality/excel';
      data.name_file = `${i18n.t('quality.quality')}.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('quality/quality')
        .then((response) => {
          this.hideSkeletonBody();
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  destroyed() {
    this.deselectedItemOnMenu('quality');
  },
};
</script>
<style></style>
